import { subscriptionActionTypes } from '../actions/types';

const initialState = {
  subscriptions: [],
  status: null,
  invoice: null,
  currentSubscription: null,
  hasSubscription: false,
  subRemainedDays: 0,
};

export function subscription(state = initialState, action) {
  switch (action.type) {
    case subscriptionActionTypes.RESET_STATE:
      return {
        ...initialState,
      };
    case subscriptionActionTypes.FETCH_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case subscriptionActionTypes.FETCH_SUCCESS:
      return {
        ...state,
        status: 'loaded',
        subscriptions: action.subscriptions,
        error: null,
      };
    case subscriptionActionTypes.FETCH_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    case subscriptionActionTypes.FETCH_LIST_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case subscriptionActionTypes.FETCH_LIST_SUCCESS:
      return {
        ...state,
        status: 'loaded',
        subscriptions: action.list,
        error: null,
      };
    case subscriptionActionTypes.FETCH_LIST_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    case subscriptionActionTypes.CREATE_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case subscriptionActionTypes.CREATE_SUCCESS:
      return {
        ...state,
        status: 'success',
        invoice: action.invoice,
        error: null,
      };
    case subscriptionActionTypes.CREATE_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    case subscriptionActionTypes.CANCEL_DRAFT_REQUEST:
      return {
        ...state,
        status: 'deleting',
        error: null,
      };
    case subscriptionActionTypes.CANCEL_DRAFT_SUCCESS:
      return {
        ...state,
        status: 'deleted',
        invoice: null,
        error: null,
      };
    case subscriptionActionTypes.CANCEL_DRAFT_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    case subscriptionActionTypes.PAY_INVOICE_REQUEST:
      return {
        ...state,
        status: 'paying',
        error: null,
      };
    case subscriptionActionTypes.PAY_INVOICE_SUCCESS:
      return {
        ...state,
        status: 'paid',
        error: null,
      };
    case subscriptionActionTypes.PAY_INVOICE_FAILURE:
      return {
        ...state,
        status: 'payFailed',
        error: action.error,
      };
    case subscriptionActionTypes.USE_COUPON_REQUEST:
      return {
        ...state,
        status: 'using',
        error: null,
      };
    case subscriptionActionTypes.USE_COUPON_SUCCESS:
      return {
        ...state,
        status: 'used',
        invoice: action.invoice,
      };
    case subscriptionActionTypes.USE_COUPON_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    case subscriptionActionTypes.GET_CURRENT_REQUEST:
      return {
        ...state,
        currentStatus: 'loading',
        error: null,
      };
    case subscriptionActionTypes.GET_CURRENT_SUCCESS:
      return {
        ...state,
        currentStatus: 'success',
        currentSubscription: action.subscription,
        hasSubscription: action.hasSubscription,
        subRemainedDays: action.subRemainedDays,
      };
    case subscriptionActionTypes.GET_CURRENT_FAILURE:
      return {
        ...state,
        currentStatus: 'failed',
        error: action.error,
      };
    case subscriptionActionTypes.GET_USER_REQUEST:
      return {
        ...state,
        currentStatus: 'loading',
        error: null,
      };
    case subscriptionActionTypes.GET_USER_SUCCESS:
      return {
        ...state,
        currentStatus: 'success',
        currentSubscription: action.subscription,
        hasSubscription: action.hasSubscription,
        subRemainedDays: action.subRemainedDays,
        subscriptions: action.subscriptions,
      };
    case subscriptionActionTypes.GET_USER_FAILURE:
      return {
        ...state,
        currentStatus: 'failed',
        error: action.error,
      };
    default:
      return state;
  }
}
